import React from 'react';
import { colors, layout } from 'Constants';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export default props => (
  <li>
    <FontAwesomeIcon
      icon={faCheck}
      style={{ color: colors.accent, marginRight: '16px' }}
    />
    {props.children}
  </li>
);
